import { PropertyReportButtonViewStore } from 'common/module/property-report/button/view-store';
import { PropertyReportButtonViewStoreFactory } from 'common/module/property-report/button/view-store.factory';

const service = PropertyReportButtonViewStoreFactory();

service.initialize();

export function PropertyReportButtonService(): PropertyReportButtonViewStore {
  return service;
}
